<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Güncel Borç Yok"
      type="success"
      :closable="false"
      v-if="!Borclar && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Borclar"
      v-if="Borclar"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      @current-change="CariSecimi">
      <el-table-column
        label="Cari"
        prop="Unvan">
      </el-table-column>
      <el-table-column
        width="100"
        align="right"
        label="Borç"
        prop="Borc">

      </el-table-column>
      <el-table-column
        width="100"
        align="right"
        label="Alacak"
        prop="Alacak">

      </el-table-column>
      <el-table-column
        width="100"
        align="right"
        label="Kalan"
        prop="Bakiye">

      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Bina_id"],
  data() {
    return {
      Height: window.innerHeight - 270,
      Borclar: null,
      AltToplam: {
        Borc: 0,
        Alacak: 0,
        Kalan: 0
      },
      lo: true
    }
  },
  methods: {
    CariSecimi(val) {
      this.$router.push('/vezne/odeme/' + val.Cari_id + '/' + val.Bina_id);
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.Bina_id + '/cari'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Borclar = response.Liste
            this.AltToplam = response.AltToplam
            this.$emit('Alacak', response.AltToplam.Bakiye);
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam.Borc;
      sums[2] = this.AltToplam.Alacak;
      sums[3] = this.AltToplam.Bakiye;

      return sums;
    },
  },
  created() {
    this.SayfaYukle();
    if (this.Bina_id === 'Sirket') this.Height = window.innerHeight - 230;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/Cari.vue